import React from 'react';

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis aut
        iusto placeat nobis nihil? Soluta placeat nam, dolorum dolores
        recusandae vitae accusamus odit facere minus, id est? Libero accusantium
        pariatur molestias hic sit nulla. Doloremque libero saepe enim ipsam id.
      </p>
    </section>
  );
};

export default About;
